require('./cardReplaceForm.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');
const personalDataHelper = require('utilities/personalDataHelper');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');

// @constants
const { CARD_REPLACE_ID } = require('constants/operationTypes');

class CardReplaceForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleReplaceCard = this.handleReplaceCard.bind(this);
    }

    handleReplaceCard() {
        const cardId = this.props.immCard.get('cardId');
        this.props.replaceCard(cardId);
    }

    render() {
        const { immCard, immProfile, maestroCard } = this.props;
        const cardId = immCard.get('cardId');
        const cardNumber = nonNumericFilter(immCard.get('number'));
        const operationParams = {
            'pan': cardNumber
        }
        const registeredAddress = personalDataHelper.getFormattedAddress(immProfile);
        const tooltipIcon = <i className="icon icon-informacion" />;
        const tooltipText = <FormattedText value="cardReplace-tooltipAddress" />
        const operative = formatText('operatives-cardReplace');

        return (
            <OKSectionBox className="card-replace-form">
                <header className="card-replace-form__header">
                    <FormattedText value="cardReplace-securityConfirmation" />
                </header>
                <p>
                <OKMessage type="important">
                    <FormattedText value="cardReplace-confirmationWarningMessage" />
                </OKMessage>
                </p>
                {maestroCard &&
                <p>
                <OKMessage type="important">
                    <FormattedText value="cardReplace-newCardWarningMessage" />
                 </OKMessage>
                </p>
                }
             

                <section className="card-replace-form__content">
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={operative}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <FormattedText value="cardReplace-legendInform" className="card-replace-form__top-legend" />

                    <p className="card-replace-form__address">
                        <span className="card-replace-form__address-text">{registeredAddress}</span>
                        <OKTooltip
                            content={tooltipText}
                            offset={[0, -15]}
                            target={__CONTACT_CENTER__ ? tooltipIcon : undefined}
                        />
                    </p>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <div className="card-replace-form__signature-passcode">
                        <SignaturePattern
                            operationType={CARD_REPLACE_ID}
                            operationParams={operationParams}
                        />
                    </div>
                </section>

                <footer className="card-replace-form__footer no-print-out">
                    <div className="pull-left">
                        <OKLink
                            modifier="inherit-styles"
                            to={`/myprofile/cards/${cardId}/details`}
                        >
                            <FormattedText value="cardReplace-cancel" />
                        </OKLink>
                    </div>
                    <div className="pull-right">
                        <SignaturePatternButton
                            onClick={this.handleReplaceCard}
                        >
                            <FormattedText value="cardReplace-requestReplace" />
                        </SignaturePatternButton>
                    </div>
                </footer>
            </OKSectionBox>
        );
    }
}

CardReplaceForm.propTypes = {
    immCard: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    replaceCard: PropTypes.func.isRequired,
    maestroCard: PropTypes.bool
};

module.exports = CardReplaceForm;
